import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
Vue.use(Vuex)


const TYPES = {
    'TOKEN': 'TOKEN',
    'CONFIG': 'CONFIG',
    'MEMBER': 'MEMBER',
    'ANCHORS': 'ANCHORS',
    'LANGUAGE': 'LANGUAGE'
}

export default new Vuex.Store({
    state: {
        token: "",
        language: "zh_CN",
        minfo: {},
        anchors: [],
        config: { stream_push_url: "", stream_push_id: "", upstream: 0 }
    },
    mutations: {
        [TYPES.TOKEN](state, token = '') {
            state.token = token
        },
        [TYPES.CONFIG](state, config) {
            Object.assign(state.config, config)
        },
        [TYPES.MEMBER](state, minfo) {
            state.minfo = minfo
        },
        [TYPES.ANCHORS](state, anchors = []) {
            state.anchors = anchors
        },
        [TYPES.LANGUAGE](state, language = "zh_CN") {
            state.language = language
        },
    },
    actions: {
        async setToken(context, token) {
            context.commit(TYPES.TOKEN, token)
        },
        async getMemberInfo(context) {
            const response = await api.get('/get_user_info')
            if (response.code == 200) {
                const minfo = response.data
                context.dispatch('getConfig')
                context.commit(TYPES.MEMBER, minfo)
            }
            return response.data
        },
        async getConfig(context) {
            const response = await api.get('/stream/config')
            const { anchor_list, ...config } = response.data || {}
            context.commit(TYPES.CONFIG, config)
            context.commit(TYPES.ANCHORS, anchor_list || [])
            if (config.upstream > 0) {
                setTimeout(() => {
                    context.dispatch('getConfig')
                }, (config.upstream + 5) * 1000)
            }
        },
        async setLanguage(context, language = "zh_CN") {
            context.commit(TYPES.LANGUAGE, language)
        },
    }
})